import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import {
  DriverPayGroup,
  DriverPayGroupsResponse,
  GetDriverPayGroupDetailsParams,
  GetDriverPayGroupsParams,
  UpdateDriverPayGroupStatusPayload,
} from './driver-pay.types'

const baseUrl = `${process.env.REACT_APP_ORDER_SERVICE_API}`

const userIdHeader = () => ({
  userId: window.sessionStorage.getItem('userId') ?? '',
})

export const driverPayApi = createApi({
  reducerPath: 'driverPayApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['DriverPayGroups'],
  endpoints: (builder) => ({
    getDriverPayGroups: builder.query<
      DriverPayGroupsResponse,
      GetDriverPayGroupsParams
    >({
      query: ({ status }) => ({
        url: `osapi/v1/driver-pay/groups?status=${status}`,
        headers: userIdHeader(),
      }),
      providesTags: ['DriverPayGroups'],
    }),

    getDriverPayGroupDetails: builder.query<
      DriverPayGroup,
      GetDriverPayGroupDetailsParams
    >({
      query: ({ driverId, year, week }) => ({
        url: `osapi/v1/driver-pay/groups/details?driverId=${encodeURIComponent(
          driverId
        )}&year=${year}&week=${week}`,
        headers: userIdHeader(),
      }),
    }),

    updateDriverPayGroupStatus: builder.mutation<
      { message: string },
      UpdateDriverPayGroupStatusPayload
    >({
      query: (body) => ({
        url: 'osapi/v1/driver-pay/groups/status',
        method: 'PUT',
        headers: userIdHeader(),
        body,
      }),
      invalidatesTags: ['DriverPayGroups'],
    }),
  }),
})

export const {
  useGetDriverPayGroupsQuery,
  useLazyGetDriverPayGroupDetailsQuery,
  useUpdateDriverPayGroupStatusMutation,
} = driverPayApi
